import { Card, CardContent } from "@mui/material";
import { Title } from "react-admin";
import { Settings } from "../utils/settings";
import { getUnsourcedInputs } from "../components/unsourcedInputs";

export const DebugSettings = () => {
  const setups = Settings.getDebugSettings();
  return (
    <Card>
      <Title title="Debug Settings" />
      <CardContent>{getUnsourcedInputs(setups)}</CardContent>
    </Card>
  );
};
